module.exports = __webpack_public_path__ + "static/media/DS Experiments.5ccc3d9d.csv";